﻿/// <reference path="../@types/alertify/index.d.ts" />
import { global } from "../Common/saop-common";
import { SaopServicesCore } from "../core/saop-services-core";
import { SaopAbsenceConfirmationPartiallyApproveView } from "./saop-absenceConfirmation-partially-approve-view";
import { SaopAbsenceConfirmationRejectView } from "../AbsenceConfirmation/saop-absenceConfirmation-reject-view";

export class SaopAbsenceConfirmationDetailsEvents {
    private _viewId: string
    private _libName: string;
    private _rejectViewId: string
    private _rejectBtnId: string;
    private _partiallyApproveViewId: string;
    private _partiallyApproveBtnId: string;
    private _approveBtnId: string;
    private _saopServicesCore: SaopServicesCore;
    private saopAbsenceConfirmationRejectView: SaopAbsenceConfirmationRejectView;
    private saopAbsenceConfirmationPartiallyApproveView: SaopAbsenceConfirmationPartiallyApproveView;

    constructor(viewId: string, libName: string = "") {
        this._viewId = viewId;
        this._libName = libName;
        this._rejectViewId = "#absenceConfirmationRejectView0";
        this._rejectBtnId = "#detailsKePlanDopustovZavrniBtn";
        this._partiallyApproveViewId = "#absenceConfirmationPartiallyApproveView0";
        this._partiallyApproveBtnId = "#detailsKePlanDopustovDelnoPotrdiBtn";
        this._approveBtnId = "#detailsKePlanDopustovPotrdiBtn";
        this._saopServicesCore = new SaopServicesCore();

        this.saopAbsenceConfirmationRejectView = new SaopAbsenceConfirmationRejectView(this._rejectViewId, this._libName + ".saopAbsenceConfirmationRejectView");
        this.saopAbsenceConfirmationRejectView.refreshData = this.refreshData.bind(this);

        this.saopAbsenceConfirmationPartiallyApproveView = new SaopAbsenceConfirmationPartiallyApproveView(this._partiallyApproveViewId, this._libName + ".saopAbsenceConfirmationPartiallyApproveView");
        this.saopAbsenceConfirmationPartiallyApproveView.refreshData = this.refreshData.bind(this);
    }

    init(): void {
        global.ConsoleLogDegug("SaopAbsenceConfirmationDetailsEvents.init");
        let _this = this;

        $(this._rejectBtnId).click(function () {
            _this.showRejectView(_this._rejectBtnId);   
        });

        $(this._approveBtnId).click(function () {
            _this.approve(_this._approveBtnId);
        });

        $(this._partiallyApproveBtnId).click(function () {
            _this.showPartiallyApproveView(_this._partiallyApproveBtnId)
        });
    }

    showRejectView(elementId: string): void {
        global.ConsoleLogDegug("SaopAbsenceConfirmationDetailsEvents.showRejectView");

        let elementCtrl = $(elementId);
        let leto = elementCtrl.data("leto");
        let sifraZaposleni = elementCtrl.data("sifrazaposleni");
        let zaporednaStevilka = elementCtrl.data("zaporednastevilka");
        let title = elementCtrl.data("formtitle");

        this.saopAbsenceConfirmationRejectView.title = title;
        this.saopAbsenceConfirmationRejectView.editRecord({ leto: leto, sifraZaposleni: sifraZaposleni, zaporednaStevilka: zaporednaStevilka });
    }

    approve(elementId: string): void {
        global.ConsoleLogDegug("SaopAbsenceConfirmationDetailsEvents.approve");

        let elementCtrl = $(elementId);
        let leto = elementCtrl.data("leto");
        let sifraZaposleni = elementCtrl.data("sifrazaposleni");
        let zaporednaStevilka = elementCtrl.data("zaporednastevilka");

        let data = { leto: leto, sifraZaposleni: sifraZaposleni, zaporednaStevilka: zaporednaStevilka };
        global.ConsoleLogDegug(data);

        let _this = this;

        this._saopServicesCore.afterDone = function (response) {
            if (response.alertMessage) {
                alertify.message(response.alertMessage);
            }

            if (response.viewContent) {
                $("#messageBanner").html(response.viewContent);
            }

            if (response.success) {
                _this.refreshData();
            }
        };
        this._saopServicesCore.ExecuteAction({
            action: "AbsenceConfirmation/ConfirmApproved"
            , data: data
            , type: "POST"
            , spinnerDivId: "#absenceConfirmationPendingLoading"
        });        
    }

    showPartiallyApproveView(elementId: string): void {
        global.ConsoleLogDegug("SaopAbsenceConfirmationDetailsEvents.showPartiallyApproveView");

        let elementCtrl = $(elementId);
        let leto = elementCtrl.data("leto");
        let sifraZaposleni = elementCtrl.data("sifrazaposleni");
        let zaporednaStevilka = elementCtrl.data("zaporednastevilka");
        let title = elementCtrl.data("formtitle");

        this.saopAbsenceConfirmationPartiallyApproveView.title = title;
        this.saopAbsenceConfirmationPartiallyApproveView.editRecord({ leto: leto, sifraZaposleni: sifraZaposleni, zaporednaStevilka: zaporednaStevilka });
    }

    private refreshData(): void {
        global.ConsoleLogDegug("SaopAbsenceConfirmationDetailsEvents.refreshData");
        this.refreshFormDataExtended();
    }

    refreshFormDataExtended(): void {
        global.ConsoleLogDegug("SaopAbsenceConfirmationDetailsEvents.refreshFormDataExtended");
    }
}


